
document.addEventListener("DOMContentLoaded", initFooter);

function initFooter() {
	document.querySelectorAll('.footer-col').forEach(function(col){
		var head = col.querySelector('.footer-col-head');
		if(!head) return;
		head.addEventListener('click', function(){
			var open = col.classList.toggle('open');
			head.setAttribute('aria-expanded', open ? 'true' : 'false');
		});
	});


	var form = document.querySelector('.site-footer form.footer-newsletter');
	var label = document.querySelector('.site-footer .footer-newsletter-label');
	if(!form || !label) return;
	form.addEventListener('submit', function(){
		label.textContent = "You're subscribed.";
		form.style.display = 'none';
	});
};